<header
  class="landing-header"
  [class.landing-header--solid]="isSolid"
  [class.landing-header--paid-flow]="activePaidFlow"
  role="banner">
  <div class="landing-header__bar">
    <nav class="landing-header__tabs" aria-label="Main navigation">
      @if (isAfterLogin) {
        <button
          type="button"
          class="landing-header__tab"
          [class.landing-header__tab-active]="!activePaidFlow"
          [attr.aria-current]="!activePaidFlow ? 'page' : null"
          [attr.aria-label]="epakPlatform"
          [disabled]="platformService.isSwitching()"
          (click)="onEpakTabClick()">
          <img
            [src]="epakTabLogoSrc"
            [alt]=""
            class="landing-header__tab-logo"
            aria-hidden="true" />
        </button>
        @if (canAccessWellvia) {
          <button
            type="button"
            class="landing-header__tab"
            [class.landing-header__tab--paid-service-active]="activePaidFlow"
            [attr.aria-current]="activePaidFlow ? 'page' : null"
            [attr.aria-label]="paidPlatform"
            [disabled]="platformService.isSwitching()"
            (click)="onWellviaTabClick()">
            <img
              [src]="wellviaTabLogoSrc"
              [alt]=""
              class="landing-header__tab-logo"
              aria-hidden="true" />
          </button>
        }
      } @else if (!disabledTabs) {
        <a
          routerLink="/welcome"
          class="landing-header__tab"
          [class.landing-header__tab-active]="!isPaidFlow"
          [attr.aria-label]="epakPlatform">
          <img
            [src]="epakTabLogoSrc"
            [alt]=""
            class="landing-header__tab-logo"
            aria-hidden="true" />
        </a>
        <a
          routerLink="/paid-services"
          class="landing-header__tab"
          [class.landing-header__tab--paid-service-active]="isPaidFlow"
          [attr.aria-label]="paidPlatform">
          <img
            [src]="wellviaTabLogoSrc"
            [alt]=""
            class="landing-header__tab-logo"
            aria-hidden="true" />
        </a>
      } @else {
        <span class="landing-header__tab landing-header__tab--disabled" [attr.aria-label]="epakPlatform">
          <img
            [src]="epakTabLogoSrc"
            [alt]=""
            class="landing-header__tab-logo"
            aria-hidden="true" />
        </span>
        <span class="landing-header__tab landing-header__tab--disabled" [attr.aria-label]="paidPlatform">
          <img
            [src]="wellviaTabLogoSrc"
            [alt]=""
            class="landing-header__tab-logo"
            aria-hidden="true" />
        </span>
      }
    </nav>
    <div class="landing-header__actions">
      <app-language-selector theme="dark"></app-language-selector>
      @if (isAfterLogin && isMobile) {
        <button
          type="button"
          class="landing-header__logout clear-button"
          (click)="onLogout()"
          [attr.aria-label]="'login.logOut' | translate">
          <span
            class="landing-header__icon"
            style="mask-image: url('assets/header-icons/LogOut.svg'); -webkit-mask-image: url('assets/header-icons/LogOut.svg');"
            aria-hidden="true"></span>
        </button>
      }
    </div>
  </div>
</header>
@if (isAfterLogin && isMobile) {
  <div class="landing-header__brand-bar">
    <span class="landing-header__brand-text">{{ brandName() }}</span>
  </div>
}
